import api from './api.service';

export const isPersonalMode = () => process.env.REACT_APP_DROPBOX_PERSONAL === '1';

const expandAncestors = (fullPath) => {
	const parts = fullPath.split('/').filter(Boolean);
	return parts.map((_, index) => '/' + parts.slice(0, index + 1).join('/'));
};

const errorSummary = (error) => error?.error?.error_summary || error?.error_summary || '';
const isNotFound = (error) => errorSummary(error).indexOf('not_found') !== -1;
const isConflict = (error) => errorSummary(error).indexOf('conflict') !== -1;

const getFolderMetadata = async (dbx, path) => {
	try {
		const meta = await dbx.filesGetMetadata({ path });
		return meta?.['.tag'] === 'folder' ? meta : null;
	} catch (error) {
		if (isNotFound(error)) {
			return null;
		}
		throw error;
	}
};

const ensureFolderPath = async (dbx, path) => {
	const existing = await getFolderMetadata(dbx, path);
	if (existing) {
		return existing;
	}
	let last = null;
	for (const ancestor of expandAncestors(path)) {
		try {
			const result = await dbx.filesCreateFolderV2({ path: ancestor, autorename: false });
			last = result?.metadata || null;
		} catch (error) {
			if (!isConflict(error)) {
				throw error;
			}
			last = await getFolderMetadata(dbx, ancestor);
		}
	}
	return last;
};

export const ensureProjectDropboxFolders = async (dbx, expectedPaths) => {
	const docs = await ensureFolderPath(dbx, expectedPaths.docs);
	const img = await ensureFolderPath(dbx, expectedPaths.img);
	return { docs, img };
};

const linkMatches = (row, folder) =>
	!!folder &&
	(row?.dbx_id === folder.id ||
		(row?.dbx_path_lower && folder.path_lower && row.dbx_path_lower === folder.path_lower));

export const syncDropboxLinks = async (projectId, folders, existingRows = []) => {
	const ensureLink = async (folder) => {
		if (!folder?.id || !folder?.path_lower) {
			return;
		}
		if (existingRows.some((row) => linkMatches(row, folder))) {
			return;
		}
		await api.dropbox.put('', {
			dbx_id: folder.id,
			dbx_path_lower: folder.path_lower,
			project_id: projectId
		});
	};
	await Promise.all([ensureLink(folders.docs), ensureLink(folders.img)]);
};
